import React from "react";
import cx from "classnames";

import Product from "../Product/Product";

import "./ProductContainer.css";

const ProductContainer = props => {
  const {
    exploreDisplay,
    products,
    open,
    viewAll,
    initialDisplayAmount,
    isMobile,
    isSelect,
    hasBeenAssigned,
    isSharedBox,
    isBoost,
  } = props;
  const containerStyle = cx({
    "product-grid-container": true,
    "d-flex": true,
    " flex-frw": true,
    "flex-jsb": !isMobile,
    "flex-jse": isMobile,
    "mar-h-16": isMobile
  });

  const productContainerStyle = cx({
    "d-flex": true,
    "flex-fdc": true,
    "w-50": !isMobile,
    "w-80": isMobile,
    "product-container": true
  });

  return (
    <div className={containerStyle}>
      {products.map((item, index) => {
        const hideItem = !viewAll && index > initialDisplayAmount - 1;
        if (item && !isNaN(item.productId)) {
          return (
            <div
              key={item.productId}
              style={{ display: hideItem ? "none" : "inherit" }}
              className={productContainerStyle}
            >
              <Product
                exploreDisplay={exploreDisplay}
                {...item}
                open={open}
                isSelect={isSelect}
                hasBeenAssigned={hasBeenAssigned}
                isSharedBox={isSharedBox}
                isBoost={isBoost}
              />
              {isMobile && index < products.length - 1 && (
                <div className="hor-rule" />
              )}
            </div>
          );
        }
      })}
    </div>
  );
};
export default ProductContainer;



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/ProductContainer/ProductContainer.js